<script setup lang="ts">
import ProjectNoticeDialog from '~/components/projects/ProjectNoticeDialog.vue';
import PublishProjectDialog from '~/components/projects/PublishProjectDialog.vue';
import type { Project } from '~/types/models';

interface Props {
    publishOpen: boolean;
    noticeOpen: boolean;
    publishTargetProject: Project | null;
    noticeTargetProject: Project | null;
}

defineProps<Props>();

const emit = defineEmits<{
    (event: 'update:publish-open', value: boolean): void;
    (event: 'update:notice-open', value: boolean): void;
    (event: 'publish-saved'): void;
    (event: 'notice-saved'): void;
}>();
</script>

<template>
    <PublishProjectDialog
        :open="publishOpen"
        :project="publishTargetProject"
        @update:open="emit('update:publish-open', $event)"
        @saved="emit('publish-saved')"
    />

    <ProjectNoticeDialog
        :open="noticeOpen"
        :project="noticeTargetProject"
        @update:open="emit('update:notice-open', $event)"
        @saved="emit('notice-saved')"
    />
</template>
